import {
  WORK_RIGHTS_AU_FIELDS,
  WORK_RIGHTS_AU_RESIDENCY_VALUES,
  WORK_RIGHTS_AU_DOC_TYPE_VALUES,
} from '@/core/field-names';

/**
 * Filtering fields that will only contribute to work rights
 * document completion for AU region.
 * @param fieldValueMap {Object}
 * @param fieldValueMap.value {Any}
 * @param fieldValueMap.required {Boolean}
 * @param fieldValueMap.errorList {String[]}
 * @returns {String[]}
 */
export function filterWorkRightsToBeIncluded(fieldValueMap) {
  return filterWorkRightsAU(fieldValueMap);
}

/**
 * Australian work rights completion logic
 * @param fieldValueMap {Object}
 * @returns {String[]}
 */
function filterWorkRightsAU(fieldValueMap) {
  const isAuCitizen =
    fieldValueMap[WORK_RIGHTS_AU_FIELDS.RESIDENCY]?.value ===
    WORK_RIGHTS_AU_RESIDENCY_VALUES.AU_CITIZEN;

  const isRequiredPassport =
    [
      WORK_RIGHTS_AU_RESIDENCY_VALUES.OTHER,
      WORK_RIGHTS_AU_RESIDENCY_VALUES.NZ_CITIZEN,
    ].includes(fieldValueMap[WORK_RIGHTS_AU_FIELDS.RESIDENCY]?.value) ||
    (isAuCitizen &&
      [
        WORK_RIGHTS_AU_DOC_TYPE_VALUES.AU_PASSPORT,
        WORK_RIGHTS_AU_DOC_TYPE_VALUES.FOREIGN_PASSPORT,
      ].includes(fieldValueMap[WORK_RIGHTS_AU_FIELDS.DOC_TYPE]?.value));

  const isRequiredBirthCertificate =
    isAuCitizen &&
    fieldValueMap[WORK_RIGHTS_AU_FIELDS.DOC_TYPE]?.value ===
      WORK_RIGHTS_AU_DOC_TYPE_VALUES.BIRTH_CERTIFICATE_AND_PHOTO_ID;

  const isRequiredPassportNumber =
    (isAuCitizen &&
      fieldValueMap[WORK_RIGHTS_AU_FIELDS.DOC_TYPE]?.value ===
        WORK_RIGHTS_AU_DOC_TYPE_VALUES.FOREIGN_PASSPORT) ||
    fieldValueMap[WORK_RIGHTS_AU_FIELDS.RESIDENCY]?.value ===
      WORK_RIGHTS_AU_RESIDENCY_VALUES.OTHER;

  const workRightsRule = {
    [WORK_RIGHTS_AU_FIELDS.RESIDENCY]: true,
    [WORK_RIGHTS_AU_FIELDS.DOC_TYPE]: isAuCitizen,
    [WORK_RIGHTS_AU_FIELDS.PASSPORT]: isRequiredPassport,
    [WORK_RIGHTS_AU_FIELDS.PASSPORT_NUMBER]: isRequiredPassportNumber,
    [WORK_RIGHTS_AU_FIELDS.BIRTH_CERTIFICATE]: isRequiredBirthCertificate,
    [WORK_RIGHTS_AU_FIELDS.PHOTO_ID]: isRequiredBirthCertificate,
    [WORK_RIGHTS_AU_FIELDS.COUNTRY_OF_DOCUMENT]: isRequiredPassportNumber,
    [WORK_RIGHTS_AU_FIELDS.TERMS_AND_CONDITIONS]: isRequiredPassportNumber,
  };

  return Object.keys(workRightsRule).filter((key) => {
    return workRightsRule[key];
  });
}
